export default __webpack_public_path__ + "static/media/intelligence.191362ff.svg";